import { FEATURES } from './guideData';
import GuideMedia from './GuideMedia';
import styles from './FeatureGuide.module.css';

// The heart of the guide: one deep-dive per feature. Each entry has a plain-language
// explanation of what the feature is, the exact steps to run it, and how to get the
// strongest result. The content lives in guideData.js so the Help Center search indexes the
// exact same copy. Ids match the jump links in GuideContents.

function Feature({ f }) {
  return (
    <article id={f.id} className={styles.feature}>
      <span className={styles.tag}>{f.tag}</span>
      <h2 className={styles.name}>{f.name}</h2>
      <p className={styles.what}>{f.what}</p>

      {/* One GIF per feature, from public/guide/<feature-id>.gif, shown under the summary.
          Override with a string clip id, or opt out with `media: false`. Missing files
          self-hide (see GuideMedia). */}
      {f.media !== false && <GuideMedia src={f.media || f.id} alt={`${f.name} demo`} />}

      <div className={styles.cols}>
        <div className={styles.col}>
          <h3 className={styles.colHead}>How to use it</h3>
          <ol className={styles.steps}>
            {f.steps.map((s, i) => (
              <li key={i} className={styles.stepItem}>{typeof s === 'string' ? s : s.text}</li>
            ))}
          </ol>
        </div>
        <div className={styles.col}>
          <h3 className={styles.colHead}>Get the best result</h3>
          <ul className={styles.tips}>
            {f.tips.map((t, i) => (
              <li key={i} className={styles.tipItem}>{t}</li>
            ))}
          </ul>
        </div>
      </div>

      {f.note && <p className={styles.noteLine}>{f.note}</p>}
    </article>
  );
}

export default function FeatureGuide() {
  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <div className={styles.header}>
          <span className={styles.eyebrow}>Features, one by one</span>
          <h2 className={styles.heading}>Every feature, and how to run it</h2>
          <p className={styles.lede}>
            Each feature below is laid out the same way: what it is, the steps to use it, and
            how to get the strongest result. Work through the ones you need, in any order.
          </p>
        </div>

        <div className={styles.list}>
          {FEATURES.map((f) => (
            <Feature key={f.id} f={f} />
          ))}
        </div>
      </div>
    </section>
  );
}
